module.exports = __webpack_public_path__ + "static/kim-345ba9f7389d07b89f7d0033fe6b94c8.jpg";